import { gql } from 'providers/tanstack-query/utils'

import type { Data, Variables } from './types'
import type { TypedDocumentNode } from 'providers/tanstack-query/types'

export const GET_FINANCE_REPORT: TypedDocumentNode<Data, Variables> = gql`
  query getFinanceReport($first: Int, $last: Int, $sort: FinanceSortInput) {
    financeData(first: $first, last: $last, sort: $sort)
  }
`
